import { useState, useEffect } from 'react';
import { api } from '../../lib/api';

/* [PATCH zaklep-leta-fe v1] Zaklep poslovnega leta (companies.leto_zaklenjeno_do).
   Ob uvozu prejetega racuna s storitvijo v zaklenjenem letu se datum storitve
   premakne na 1.1. prvega odprtega leta. Shrani se sproti (PUT /companies/{id}/zaklep-leta). */
export function ZaklepLetaKartica({ companyId }: { companyId: string }) {
  const [leto, setLeto] = useState<number>(0);
  const [urejam, setUrejam] = useState(false);
  const [vnos, setVnos] = useState('');
  const [shranjujem, setShranjujem] = useState(false);
  const [sporocilo, setSporocilo] = useState('');
  useEffect(() => {
    setLeto(0); setUrejam(false); setVnos(''); setSporocilo('');
    if (!companyId) return;
    api.get(`/companies/${companyId}/zaklep-leta`)
      .then((r: any) => setLeto(Number(r.data?.leto_zaklenjeno_do) || 0))
      .catch(() => {});
  }, [companyId]);
  const shrani = async (v: number) => {
    setShranjujem(true); setSporocilo('');
    try {
      await api.put(`/companies/${companyId}/zaklep-leta`, { leto_zaklenjeno_do: v });
      setLeto(v); setUrejam(false); setVnos('');
      setSporocilo(v ? `Leto zaklenjeno do vključno ${v}.` : 'Zaklep odstranjen — vsa leta so odprta.');
    } catch (e: any) {
      setSporocilo(e?.response?.data?.detail || 'Shranjevanje ni uspelo.');
    } finally { setShranjujem(false); }
  };
  const potrdi = () => {
    const s = (vnos || '').trim();
    if (!/^\d{4}$/.test(s)) { setSporocilo('Vnesi leto s štirimi števkami, npr. 2025.'); return; }
    shrani(Number(s));
  };
  return (
    <div className="bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-800 p-6 max-w-2xl">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-10 h-10 rounded-xl bg-amber-50 dark:bg-amber-950 flex items-center justify-center text-lg">📅</div>
        <div>
          <h2 className="font-semibold text-gray-900 dark:text-white">Zaklep poslovnega leta</h2>
          <p className="text-xs text-gray-500 dark:text-gray-400">Po zaključku leta ga zakleni. Prejeti in izdani računi, uvoženi po zaklepu, s storitvijo v zaklenjenem letu dobijo datum storitve 1.1. prvega odprtega leta in obdobje januar. Datum računa ostane. Datum za DDV ureja blokada davčnega obdobja; pri izdanih ostane pravi mesec (popravek DDV ob potrditvi). Že uvoženi računi se ne spremenijo.</p>
        </div>
      </div>
      <div className="mt-4 space-y-3">
        {leto > 0 && !urejam && (
          <div className="flex items-center gap-3">
            <span className="px-3 py-1.5 rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 text-sm font-semibold">Zaklenjeno do vključno: {leto}</span>
            <button onClick={() => { setVnos(String(leto)); setUrejam(true); setSporocilo(''); }} className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:border-blue-400">Spremeni</button>
            <button onClick={() => shrani(0)} disabled={shranjujem} className="text-xs px-3 py-1.5 rounded-lg border border-gray-300 dark:border-gray-600 text-red-500 hover:border-red-400 disabled:opacity-50">Odkleni</button>
          </div>
        )}
        {leto === 0 && !urejam && (
          <div className="flex items-center gap-3">
            <span className="text-sm text-gray-500 dark:text-gray-400">Ni zaklepa — vsa leta so odprta.</span>
            <button onClick={() => { setVnos(''); setUrejam(true); setSporocilo(''); }} className="text-xs px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold">+ Zakleni leto</button>
          </div>
        )}
        {urejam && (
          <div className="flex items-center gap-2">
            <input autoFocus value={vnos} onChange={e => setVnos(e.target.value)} placeholder="YYYY (npr. 2025)"
              onKeyDown={e => { if (e.key === 'Enter') potrdi(); if (e.key === 'Escape') { setUrejam(false); setSporocilo(''); } }}
              className="w-36 px-3 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-900 dark:text-white outline-none focus:border-blue-500 text-sm font-mono" />
            <button onClick={potrdi} disabled={shranjujem} className="text-xs px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold disabled:opacity-50">{shranjujem ? 'Shranjujem...' : 'Shrani'}</button>
            <button onClick={() => { setUrejam(false); setSporocilo(''); }} className="text-xs px-3 py-2 rounded-lg text-gray-400 hover:text-gray-300">Prekliči</button>
          </div>
        )}
        {sporocilo && <p className="text-[11px] text-gray-500">{sporocilo}</p>}
      </div>
    </div>
  );
}
